import React from 'react';
import { Trans } from 'react-i18next';

export default [
    { value: 'desc', label: <Trans ns="dm.article" i18nKey="search-filter_order-desc">Synkende</Trans> },
    { value: 'asc', label: <Trans ns="dm.article" i18nKey="search-filter_order-asc">Stigende</Trans> }
];
